import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHashHistory, RouteMeta } from 'vue-router'
import { Routes } from '@/common/constants'

interface ICustomRouteMeta extends RouteMeta {
  keepAlive?: boolean
}

const routes: RouteRecordRaw[] = [
  {
    name: Routes.Majblomman,
    path: '/',
    component: () => import('@/features/majblomman/Majblomman.vue'),
    meta: {} as ICustomRouteMeta
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to, from) => {
  routeInfo.toName = String(to.name)
  routeInfo.fromName = String(from.name)

  document.getElementById('splashScreen')!.style.display = 'none'
})

export const routeInfo = {
  toName: '',
  fromName: ''
}

export default router
